import { render, staticRenderFns } from "./addMember.vue?vue&type=template&id=c5b864d0&scoped=true"
import script from "./addMember.vue?vue&type=script&lang=js"
export * from "./addMember.vue?vue&type=script&lang=js"
import style0 from "./addMember.vue?vue&type=style&index=0&id=c5b864d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b864d0",
  null
  
)

export default component.exports